import React from 'react';
import { BasicHomeMart } from './BasicHomeMart';

export const BasicMart = (props) => {
    return (
        props.listings.map(listing => {
            return (
                <BasicHomeMart
                    {...props}
                    key={listing.hpId}
                    listing={listing}
                    isViewed={props.viewedContentIds.includes(listing.hpId)}
                />
            )
        })
    )
}